import { cn } from "@RHCommerceDev/utils/cn";
import React from "react";
import { Typography } from "@RHCommerceDev/unstyled-ui-components";
import memoize from "@RHCommerceDev/utils/memoize";
import he from "he";

interface CatalogNavigationProps {
  categories: Array<NavigationElement>;
  selectedCategoryIndex: number;
  isFrenchCanada: boolean;
  onCategoryLinkClick: (
    event: React.MouseEvent,
    category: NavigationElement
  ) => void;
  onCategoryDropdownToggle: (categoryIndex: number) => void;
}

const CatalogNavigation = ({
  categories,
  selectedCategoryIndex,
  isFrenchCanada,
  onCategoryLinkClick,
  onCategoryDropdownToggle
}: CatalogNavigationProps) => {
  return (
    <>
      {/* Navigation is hidden below md */}
      <nav
        aria-label="Catalog navigation"
        onClick={e => {
          //this stop dropdown to close when clicked
          e.stopPropagation();
        }}
      >
        <ul
          className={cn(
            "hidden h-[23px] w-full flex-nowrap items-center justify-between p-0 px-10 md:flex xl:px-20"
          )}
        >
          {categories?.map((category, index) => (
            <li key={index}>
              <button
                onClick={e => {
                  if (!!category?.childCategories?.length) {
                    onCategoryDropdownToggle(index);
                  } else {
                    onCategoryLinkClick(e, category);
                  }
                }}
                className="p-0 text-inherit"
              >
                <Typography
                  variant="default"
                  fontFamily={
                    index === selectedCategoryIndex ? "rhcRoman" : "rhc"
                  }
                  fontWeight={
                    index === selectedCategoryIndex ? "normal" : "thin"
                  }
                  data-analytics-rootcat={category.displayName}
                  className={cn(
                    "text-center text-[13px] uppercase leading-[1.5em] lg:text-base lg:leading-[1.4375em]",
                    index === selectedCategoryIndex
                      ? "tracking-[0.025em]"
                      : "tracking-[0.05em]",
                    {
                      "opacity-30":
                        selectedCategoryIndex !== -1 &&
                        index !== selectedCategoryIndex,
                      "md:text-[11px] lg:text-[13px] xl:text-base":
                        isFrenchCanada
                    }
                  )}
                  dangerouslySetInnerHTML={{
                    __html: he.decode(category?.displayName ?? "")
                  }}
                />
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default memoize(CatalogNavigation);
